export class SubscriptionPlanAddModel {
    public name: string;
    public totalSmallImages: number;
    public totalMediumImages: number;
    public totalLargeImages: number;
    public price: number;
}